import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PageNotFoundHomeStore {

}

export enum PageNotFoundHomeStoreKeys {

}
